import axios from 'axios'
import authService from './authService'

const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8001/api'

class ApiService {

  async get(endpoint, params = {}) {
    try {
      const response = await axios.get(`${API_URL}${endpoint}`, {
        ...params
      });

      // Ha blob response, akkor adjuk vissza a teljes response objektumot
      if (params.responseType === 'blob') {
        return {
          success: true,
          data: response.data,
          headers: response.headers,
          status: response.status,
          // Teljes response objektum is elérhető
          response: response
        };
      }

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'API hiba',
        status: error.response?.status,
        headers: error.response?.headers
      };
    }
  }

  async post(endpoint, data) {
    try {
      const response = await axios.post(`${API_URL}${endpoint}`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'API hiba'
      }
    }
  }

  async put(endpoint, data) {
    try {
      const response = await axios.put(`${API_URL}${endpoint}`, data)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'API hiba'
      }
    }
  }

  async delete(endpoint) {
    try {
      const response = await axios.delete(`${API_URL}${endpoint}`)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'API hiba'
      }
    }
  }

  getApiURL() {
    return API_URL;
  }

  // Partner specifikus API hívások
  async getPartnerData() {
    const userId = authService.getUserId()
    return this.get(`/partners/${userId}`)
  }

  async updatePartnerData(data) {
    const userId = authService.getUserId()
    return this.put(`/partners/${userId}`, data)
  }

  async getPartnerStats() {
    const userId = authService.getUserId()
    return this.get(`/partners/${userId}/stats`)
  }
}

export default new ApiService()